import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOctopusdeployComponent } from './simple-icons-octopusdeploy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOctopusdeployComponent ],
    exports:      [ SimpleIconsOctopusdeployComponent ],
    bootstrap:    []
})
export class SimpleIconsOctopusdeployModule {}
